export const WorkData = [
	{
		title: "RealAdvisor",
		desc: "RealAdvisor Pro helps you list more homes by connecting you to homeowners actively looking to sell",
		tech: ["React.js", "Wordpress", "MySQL", "Cloudflare"],
		gitlink: "//github.com/Pappyjay23/netflix-clone",
		site: "//realadvisor.com/",
	},
	{
		title: "Alternative Investments",
		desc: "This website opens up the world of alternative investments for users",
		tech: ["NFT", "Web3"],
		gitlink: "//github.com/Pappyjay23/netflix-clone",
		site: "//investwithcarl.com/",
	},
	{
		title: "MoonStep",
		desc: "The Moon Step Sneakers NFT is a multifunctional activity tracker that can help you monitor your health and earn Tokens daily.",
		tech: ["React.js", "Wordpress", "MySQL", "Cloudflare"],
		gitlink: "//github.com/Pappyjay23/netflix-clone",
		site: "//nft-dao.mobiloitte.org/",
	}
];
